<script>
import { ref, reactive, toRefs, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import fileComp from '@/compositions/modules/file'
import SrUpload from '@/components/SrUpload'
import { useI18n } from "@/plugins/i18n"
const { t } = useI18n()

export default {
  components: {
    SrUpload
  },
  props: {
    checkShareHolder: {
      type: Boolean,
      default: false
    },
    certTitle: {
      type: String,
      default: t('auth.company.info.label.text_6')
    },
    scopeData: {
      type: Object,
      default: () => {
        return {
          certType: 'I',
          frontFileId: '',
          frontFileName: '',
          backFileId: '',
          backFileName: ''
        }
      }
    },
    compRegRegion:{
      type: String,
      default: ""
    }
  },
  setup(props) {
    const { FILE } = useStore().state.base.constant
    const { template } = fileComp()
    const { t } = useI18n()
    const store = useStore();
    // 文件类型列表
    const certTypeList = ref([
      { label: t('common.label.identityCard'), value: 'I' },
      { label: t('common.label.passport'), value: 'P' },
      // { label: '港澳通行证', value: 'H' }
    ])

    

    const idTypeEnum = {
    I: t('common.label.identityCard'),
    P: t('common.label.passport'),
    H: t('common.label.identityCard'),
  }
    // 示例文件列表
    const exFileList = reactive({
      frontFile: {
        I: template.idCardFront,
        P: template.passport,
        H: template.HKAndMOPassFront
      },
      backFile: {
        I: template.idCardBack,
        P: null,
        H: template.HKAndMOPassBack
      }
    })

    const form = reactive({
      certType: 'L',
      frontFileId: '',
      frontFileName: '',
      backFileId: '',
      backFileName: '',
      holdInterval: false
    })
    // refs
    const refs = reactive({
      formRef: null
    })

    watchEffect(() => {
      Object.assign(form, props.scopeData)
    })

    const validateForm = async() => {
      let flag = false
      await refs.formRef.validate(valid => {
        if (valid) {
          flag = true
        }
      })
      return flag
    }

    watch(
      [
        () => form.frontFileId,
        () => form.backFileId
      ],
      ([frontFileId, backFileId]) => {
        if (frontFileId) {
          refs.formRef.clearValidate('frontFileId')
        }
        if (backFileId) {
          refs.formRef.clearValidate('backFileId')
        }
      }
    )

    const handleDisabled = () => {
      return form.userCheckStatus && !['RJ', 'RC', 'ST', 'WC'].includes(form.userCheckStatus)
    }

    return {
      ...toRefs(refs),
      FILE,
      certTypeList,
      exFileList,
      handleDisabled,
      form,
      t,
      validateForm,
      idTypeEnum,
      store
    }
  }
}
</script>

<template>
  <div class="card-component-container">
    <el-form
        :model="form"
        ref="formRef"
        :disabled="handleDisabled()"
        :label-width="localCN?'150px':'230px'"
        label-position="left">
      <el-form-item
          :label="certTitle"
          prop="certType"
          :rules="{ required: true, message: `${localCN?'请选择':'Place select '}${certTitle}`, trigger:'change' }">
        <div>
          <el-select v-model="form.certType" :disabled="form.disabledSelect">
            <el-option
                v-for="(item, index) in certTypeList"
                :key="index"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="idTypeEnum[form.certType]" :rules="{ required: true }">
        <div class="auth-upload-container">
          <div class="upload-title-wrap"  >
              <div class="h2" style="height: 40px;line-height: 40px;" >{{form.certType==='P'?t('common.content.passportHint'):t('common.content.identityCardHint')}}
                
            </div>
          </div>
          <div class="auth-upload-wrap">
            <div class="auth-upload-item">
              <el-form-item class="upload-item" prop="frontFileId"
                            :rules="{required: true, message: form.certType==='P'?t('common.validate.passport'):t('common.placeholder.identityCardFront'), trigger:'change'}">
                <sr-upload
                    v-model:fileId="form.frontFileId"
                    v-model:fileName="form.frontFileName"
                    :filePrefix="FILE.PREFIX.FRONT_FILE"
                    fileSize="5"
                    :uploadDesc="t('common.label.upload')"
                    
                    :mode="(handleDisabled()||form.disabledSelect)?FILE.UPLOAD_MODE.READONLY:FILE.UPLOAD_MODE.EDITABLE"/>
              </el-form-item>
              <div class="h3">{{form.certType==='P'?t('common.content.passport'):t('common.content.identityCardFront')}}</div>
            </div>

            <div class="auth-upload-item" v-if="form.certType!=='P'">
              <el-form-item class="upload-item" prop="backFileId"
                            :rules="{required: true, message: t('common.placeholder.identityCardBack'), trigger:'change'}">
                <sr-upload
                    v-model:fileId="form.backFileId"
                    v-model:fileName="form.backFileName"
                    :filePrefix="FILE.PREFIX.BACK_FILE"
                    fileSize="5"
                    :uploadDesc="t('common.label.upload')"
                    
                    :mode="(handleDisabled()||form.disabledSelect)?FILE.UPLOAD_MODE.READONLY:FILE.UPLOAD_MODE.EDITABLE"/>
              </el-form-item>
              <div class="h3">{{t('common.content.identityCardBack')}}</div>
            </div>

          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="store.state.auth.step<2&&(compRegRegion=='CN'||compRegRegion=='TW')">
        <div class="auth-check">
          <el-checkbox v-model="form.holdInterval">
            <span style="color: #677280;">{{t('auth.company.info.content.text_12')}}</span>
            <span class="auth-tip">{{t('auth.company.info.content.text_20')}}</span>
          </el-checkbox>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
  .card-component-container {
    .auth-upload-container {
      width: 100%;
      box-sizing: border-box;

      .auth-upload-wrap {
        width: 100%;
        display: flex;

        .auth-upload-item {
          margin-right: 60px;

          .upload-item {
            margin-bottom: 15px;
          }
        }
      }
    }

    :deep(.el-form-item__content) {
      flex: inherit;
      width: auto;

      .el-input__inner, .el-textarea__inner {
        width: 360px !important;
        border-radius: 4px !important;
      }
      .el-select{
        width: 390px !important;
        border-radius: 4px !important;
      }
      .el-input__wrapper{
        width: 100%;
      }

      .el-input {
        width: auto;
      }
    }
  }
</style>
